module.exports = __webpack_public_path__ + "static/media/Arunachalam.9e3acaee.jpg";